import { WithClassName } from '@/blocks/components/types';
import typography from '@/styles/typography.module.scss';
import classNames from 'classnames';
import { PropsWithChildren, ReactNode } from 'react';
import { Panel } from '../Panel';
import styles from './styles.module.scss';

type CardProps = PropsWithChildren<
  {
    title: ReactNode;
    headingComponent?: React.ReactNode;
    bordered?: boolean;
    padding?: 'small' | 'regular' | 'vertical';
    innerContentMaxWidthDesktop?: number;
  } & WithClassName
>;

export function Card({
  title,
  children,
  className,
  headingComponent = null,
  padding = 'regular',
  bordered = true,
  innerContentMaxWidthDesktop,
}: CardProps) {
  return (
    <Panel
      innerContentMaxWidthDesktop={innerContentMaxWidthDesktop}
      className={classNames(
        styles.card,
        {
          [styles.bordered]: bordered,
          [styles.verticalPadding]: padding === 'vertical',
          [styles.regularPadding]: padding === 'regular',
          [styles.smallPadding]: padding === 'small',
        },
        className,
      )}
    >
      <div className={styles.cardHeading}>
        <h2 className={typography.subheadingM}>{title}</h2>
        {headingComponent}
      </div>
      {children}
    </Panel>
  );
}
